import { Image } from 'antd';
import React, { FC } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { RoutePaths } from 'constant';
import { useAccountMetaQuery } from 'queries';

const StyledPage = styled(Page)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--zindex-popover);
  align-items: center;
  padding: var(--spacing-07);
`;

const CenterAlignedDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

const Message = styled.h2`
  text-align: center;
  padding: var(--spacing-05);
`;

export const MobileViewOverlay: FC = ({ children }) => {
  const { data } = useAccountMetaQuery();
  const excludedSimpleRoutes = [
    RoutePaths.linkAction,
    RoutePaths.addApiKey,
    RoutePaths.respSpacesTab,
  ];
  const {
    location: { pathname },
  } = useHistory();

  const byPassMobileScreenCheck = () => {
    const splitPathname = pathname.split('/');

    if (excludedSimpleRoutes.includes(pathname)) {
      return true;
    }

    if (
      pathname.includes('responsive') ||
      pathname.includes('api-key') ||
      (pathname.startsWith('/forms') &&
        splitPathname[2] !== undefined &&
        splitPathname[3] !== undefined)
    ) {
      return true;
    }
    if (navigator.userAgent.includes('Mobile') && pathname.includes('login')) {
      return true;
    }

    return true;
  };

  return (
    <>
      {!byPassMobileScreenCheck() && isMobileOnly ? (
        <StyledPage>
          {data && data.company?.companyLogoUrl ? (
            <Image
              width={80}
              height={80}
              preview={false}
              src={data.company.companyLogoUrl}
              title="logo"
              alt="logo"
            />
          ) : null}

          <CenterAlignedDiv>
            <Message>
              <FormattedMessage id="mobile_view.message" />
            </Message>
          </CenterAlignedDiv>
        </StyledPage>
      ) : (
        children
      )}
    </>
  );
};
